var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0.886
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,4 L18,4 C19.1045695,4 20,4.8954305 20,6 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,6 C4,4.8954305 4.8954305,4 6,4 L8.5,4 C8.5,2.89543050 9.3954305,2 10.5,2 L13.5,2 C14.6045695,2 15.5,2.89543050 15.5,4 Z M14.5,4 C14.5,3.44771525 14.0522847,3 13.5,3 L10.5,3 C9.94771525,3 9.5,3.44771525 9.5,4 L9.5,5 L14.5,5 L14.5,4 Z M8.5,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,20 C5,20.5522847 5.44771525,21 6,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,6 C19,5.44771525 18.5522847,5 18,5 L15.5,5 L15.5,6 L8.5,6 L8.5,5 Z M8,10 L16,10 L16,11 L8,11 L8,10 Z M8,13 L16,13 L16,14 L8,14 L8,13 Z M8,16 L13,16 L13,17 L8,17 L8,16 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.73dbfecaf9e914df58b1df04e5d168dc.svg";
export { ForwardRef as ReactComponent };